import React, { useMemo } from 'react'
import { useParams, useNavigate, useLocation, Routes, Route } from 'react-router-dom'
import { Tabs, theme } from 'antd'
import { Settings, Blocks } from 'lucide-react'
import ChatBotFlowEdit from './index'
import Integrations from './Integrations'

export default function ChatBotFlowEditWrapper() {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const {
    token: { colorBgContainer, borderRadius, colorBorderSecondary },
  } = theme.useToken()

  const locationSplit = location?.pathname?.split('/')
  const selectedKey = useMemo(() => {
    const last = locationSplit[locationSplit?.length - 1]
    return last === id ? 'settings' : last
  }, [locationSplit, id])

  const menuItems = [
    {
      label: 'Configurações',
      key: 'settings',
      icon: <Settings size={18} className="inline-block pb-0.5" />,
    },
    {
      label: 'Integrações',
      key: 'integrations',
      icon: <Blocks size={18} className="inline-block pb-0.5" />,
    },
  ]

  const onTabClick = (key) => {
    if (key === 'settings') {
      navigate(`/chatbots/${id}`)
    } else {
      navigate(`/chatbots/${id}/${key}`)
    }
  }

  return (
    <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Tabs
        type="card"
        items={menuItems}
        tabBarStyle={{ margin: 0 }}
        activeKey={selectedKey}
        animated
        onTabClick={onTabClick}
      />
      <div
        style={{
          background: colorBgContainer,
          color: colorBorderSecondary,
          borderWidth: '0 1px 1px 1px',
          borderRadius: `0 ${borderRadius}px ${borderRadius}px ${borderRadius}px`,
          padding: '1rem',
        }}
      >
        <Routes>
          <Route index element={<ChatBotFlowEdit redirect={false} />} />
          <Route
            path="integrations"
            element={
              <Integrations
                id={id}
              />
            }
          />
        </Routes>
      </div>
    </div>
  )
}
